import { render, staticRenderFns } from "./ChatTags.vue?vue&type=template&id=68af5b84&"
import script from "./ChatTags.vue?vue&type=script&lang=js&"
export * from "./ChatTags.vue?vue&type=script&lang=js&"
import style0 from "./ChatTags.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports